import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TBranch } from 'components/Registration/registration.types';
import { getAvailableBranches } from 'components/Registration/RegistrationFormDE/RegistrationFormDE.helpers';
import { useParams, useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const ALLOWED_COMPANIES = [
  {
    id: 'commerzbank',
    name: 'Commerzbank',
    branchLabel: 'UK-Standort',
    emailValidation: /@commerzbank\.com$/,
    emailPlaceholder: 'maxmuster@commerzbank.com',
    emailExample: '@commerzbank.com',
  },
];

export function useCompanyRegistrationDE() {
  const { headquarters } = useParams();
  const navigate = useNavigate();

  const company = ALLOWED_COMPANIES.find((c) => c.id === headquarters) || null;

  useEffect(() => {
    if (headquarters && !company) {
      navigate(PATH_NAMES.notFound());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  const queryFn = async () => {
    if (!company) return [];
    return await getAvailableBranches({
      headquarters: company.name,
    });
  };

  const { data: availableBranches, isLoading: isLoadingBranches } = useQuery<
    TBranch[]
  >({
    queryKey: ['availableBranches', company],
    queryFn,
    enabled: Boolean(company),
  });

  return {
    company,
    availableBranches,
    isLoadingBranches,
  };
}
